import React, { useState, useEffect } from 'react';
import './Aside.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { getAsideEntries } from '../../api/api';
import { useAuthStore } from '../../store/authStore';
import AsideModal from '../AsideModal/AsideModal';
import Loader from '../Loader/Loader'; //  wspólny loader

const Aside = () => {
  const { isAuthenticated } = useAuthStore();

  const [asideData, setAsideData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMode, setModalMode] = useState('add');
  const [editingEntry, setEditingEntry] = useState(null);
  const [selectedType, setSelectedType] = useState(null);

  useEffect(() => {
    const fetchAside = async () => {
      setLoading(true);
      try {
        const data = await getAsideEntries();
        setAsideData(data.sort((a, b) => a.sortOrder - b.sortOrder));
      } catch (err) {
        console.error('Błąd pobierania aside:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchAside();
  }, []);

  const grouped = asideData.reduce((acc, item) => {
    acc[item.type] = acc[item.type] || [];
    acc[item.type].push(item);
    return acc;
  }, {});

  const personal = grouped.personal?.[0];
  const info = grouped.info || [];
  const social = grouped.social || [];

  const openModal = (entry = null, mode = 'add', type = null) => {
    setEditingEntry(entry);
    setModalMode(mode);
    setSelectedType(type);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setEditingEntry(null);
    setModalMode('add');
    setSelectedType(null);
  };

  const handleSave = (saved) => {
    if (!saved) {
      // usunięto
      setAsideData((prev) =>
        prev.filter((item) => item.id !== editingEntry.id)
      );
    } else if (editingEntry?.id) {
      // edycja
      setAsideData((prev) =>
        prev.map((item) => (item.id === saved.id ? saved : item))
      );
    } else {
      // dodanie
      setAsideData((prev) =>
        [...prev, saved].sort((a, b) => a.sortOrder - b.sortOrder)
      );
    }
    closeModal();
  };

  // Avatar
  const avatarUrl = personal?.iconUrl || '/assets/images/awatar.jpg';

  if (loading) {
    return <Loader />;
  }

  return (
    <aside className="Aside">
      <div
        className="avatar"
        style={{ backgroundImage: `url(${avatarUrl})` }}
      ></div>

      {personal ? (
        <>
          <h1 className="name-surname">{personal.title}</h1>
          <h2 className="status">{personal.subtitle}</h2>
        </>
      ) : (
        <div className="empty-personal">
          <p>Brak danych osobowych</p>
        </div>
      )}

      <div className="line-"></div>

      <div className="container-information">
        {info.map((item) => (
          <div key={item.id} className="info">
            {item.iconUrl ? (
              <div className="column-pht">
                <img src={item.iconUrl} alt={item.title} />
              </div>
            ) : (
              <div className="column-pht">
                <i
                  className={`fa-brands fa-${item.title?.toLowerCase() || 'question'}`}
                ></i>
              </div>
            )}
            <div className="column-txt">
              <h3 className="title">{item.title}:</h3>
              <p className="text">{item.subtitle}</p>
            </div>
          </div>
        ))}

        <div className="social-icon">
          <ul>
            {social.map((item) => {
              const href = item.url?.startsWith('http')
                ? item.url
                : item.subtitle?.startsWith('http')
                  ? item.subtitle
                  : `https://${item.subtitle}`;

              return (
                <li key={item.id}>
                  <a href={href} target="_blank" rel="noopener noreferrer">
                    {item.iconUrl ? (
                      <img
                        src={item.iconUrl}
                        alt={item.title}
                        style={{ width: '30px', height: '30px' }}
                      />
                    ) : (
                      <i
                        className={`fa-brands fa-${item.title?.toLowerCase() || 'question'}`}
                      ></i>
                    )}
                  </a>
                </li>
              );
            })}
          </ul>
        </div>
      </div>

      {isAuthenticated && (
        <div className="admin-sidebar-btns">
          <button onClick={() => openModal(null, 'add')}>
            + Dodaj wpis sidebar
          </button>
          <button onClick={() => openModal(null, 'select-edit')}>
            Edytuj / Usuń wpis
          </button>
        </div>
      )}

      {modalOpen && (
        <AsideModal
          entry={editingEntry}
          onClose={closeModal}
          onSave={handleSave}
          entries={asideData}
          mode={modalMode}
          typeForSelection={selectedType}
          onSelectEdit={(selectedEntry) => openModal(selectedEntry, 'edit')}
        />
      )}
    </aside>
  );
};

export default Aside;
